export { COOKIE_CONSENT_ACCEPT_EVENT_NAME, COOKIE_NAME, COOKIE_POLICY_ID, DEFAULT_COOKIE_EXPIRY, SIMPLE_COOKIE_NAME } from './chunk-R6LOGD7N.mjs';

// src/index.ts
var getConsentCookie = () => {
  let consentCookie = null;
  if (typeof document !== "undefined" && document.cookie) {
    consentCookie = document.cookie.match(
      new RegExp("(^|;) ?twCookieConsent=([^;]*)(;|$)")
    );
  }
  return consentCookie ? JSON.parse(decodeURIComponent(consentCookie[2])) : null;
};
var cookie = {
  write: (cookie2, params) => {
    if (params && params.essential) {
      document.cookie = cookie2;
    }
    if (hasValidConsent()) {
      document.cookie = cookie2;
    }
  }
};
var hasValidConsent = () => {
  let consentCookie = getConsentCookie();
  let isAccepted = !!(consentCookie && consentCookie.status === "accepted");
  return isAccepted;
};

export { cookie, hasValidConsent };
//# sourceMappingURL=index.mjs.map
//# sourceMappingURL=index.mjs.map